import { render, staticRenderFns } from "./ComApiwarn.vue?vue&type=template&id=29d53a26&scoped=true&"
import script from "./ComApiwarn.vue?vue&type=script&lang=js&"
export * from "./ComApiwarn.vue?vue&type=script&lang=js&"
import style0 from "./ComApiwarn.vue?vue&type=style&index=0&id=29d53a26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d53a26",
  null
  
)

export default component.exports